import React from 'react';
import $ from "jquery";


class GpyModalAlert extends React.Component {

	constructor(props) {
   super(props);
	 this.close = this.close.bind(this);
   this.state = {
          title: this.props.title!==undefined?this.props.title:"",
					body: this.props.body!==undefined?this.props.body:"",
					text: this.props.text!==undefined?this.props.text:"danger",
					icon: this.props.icon!==undefined?this.props.icon:"alert",
					close: this.props.close !==undefined? this.props.close : this.close,
        };
   }

	componentDidMount (){
		this.props.parent.registerEvent("GpyModal"+Math.random(),this);
	}



	showModal(obj,t,b,c){
		console.log("show",obj,"title",t,"body",b,"close",c);

	 if(t !== undefined){
		 	this.setState({title:t});
	 }
	 if(b !== undefined){
		 	this.setState({body:b});
   }
	 if(c !== undefined){
		 	console.log("C",c);
		 this.setState( { close: c} );
		 	console.log("c2",this.state.close);
   }

		if(obj) {
			this.show();
		} else {
			this.hide();
		}
	}

	show(){
		 $(this.modal).modal('show');
	}

	hide(){
		 $(this.modal).modal('hide');
	}



	close() {
	}

	doClose(){
		if(this.state.close !== undefined){
			console.log(this.state.close);
			this.state.close();
		}
	}

  render () {

	 return (
				      <div className="modal fade" ref={modal=> this.modal = modal} tabIndex="-1" role="dialog" aria-labelledby="gpyModalLabel" aria-hidden="true">
			        		<div className="modal-dialog modal-lg" role="document">
											<div className="modal-content">
			                            <div className="modal-header">
			                                <h5 className={"modal-title text-"+this.state.text}><span className={"glyphicon glyphicon-"+this.state.icon+" text-"+this.state.text} aria-hidden="true"></span>  {this.state.title}</h5>
			                            </div>
			                            <div className="modal-body">
			                                {this.state.body}
			                            </div>
																	{this.props.close!==undefined?
																	<div className="modal-footer">
																	        <button type="button" onClick={this.doClose.bind(this)} className="btn btn-secondary" data-dismiss="modal">Close</button>
																	</div>
																	:""}

			                 </div>
			           </div>
			       </div>
					 );
    }
}
export default GpyModalAlert;
